import { LINE_BREAK_RANGES } from "./line-break-data.js";
const WJ = 22;
const ZWJ = 31;
const BK = 34;
const CR = 36;
const LF = 37;
const NL = 38;
const SP = 41;
const DI_BRK = 0;
const IN_BRK = 1;
const CI_BRK = 2;
const PAIR_TABLE = [
  "444444444444444444444344444444444",
  // OP
  "044114444110000111004240000000010",
  // CL
  "044114444111110111004240000000010",
  // CP
  "444111444111111111114241111111111",
  // QU
  "144111444111111111114241111111111",
  // GL
  "044111444000000111004240000000010",
  // NS
  "044111444000000111004240000000010",
  // EX
  "044111444001010111004240000000010",
  // SY
  "044111444001110111004240000000010",
  // IS
  "144111444001111111004241111101110",
  // PR
  "144111444001110111004240000000010",
  // PO
  "144111444111110111004240000000010",
  // NU
  "144111444111110111004240000000010",
  // AL
  "144111444111110111004240000000010",
  // HL
  "044111444010000111004240000000010",
  // ID
  "044111444000000111004240000000010",
  // IN
  "044101444001000111004240000000010",
  // HY
  "044101444000000111004240000000010",
  // BA
  "144111444111111111114241111111110",
  // BB
  "044111444000000111044240000000010",
  // B2
  "000000000000000000004000000000000",
  // ZW
  "144111444111110111004240000000010",
  // CM
  "144111444111111111114241111111111",
  // WJ
  "044111444010000111004240001100010",
  // H2
  "044111444010000111004240000100010",
  // H3
  "044111444010000111004241111000010",
  // JL
  "044111444010000111004240001100010",
  // JV
  "044111444010000111004240000100010",
  // JT
  "044111444000000111004240000010010",
  // RI
  "044111444010000111004240000000110",
  // EB
  "044111444010000111004240000000010",
  // EM
  "144111444111110111004240000000010",
  // ZWJ
  "044110444000000000004240000000010"
  // CB
];
const rangeStarts = [];
const rangeClasses = [];
{
  let start = 0;
  let delta = 0;
  for (let i = 0; i < LINE_BREAK_RANGES.length; i++) {
    const code = LINE_BREAK_RANGES.charCodeAt(i);
    if (code >= 97) {
      delta = delta * 26 + (code - 97);
    } else {
      start += delta;
      rangeStarts.push(start);
      rangeClasses.push(code - 48);
      delta = 0;
    }
  }
}
const getLineBreakClass = (codePoint) => {
  let low = 0;
  let high = rangeStarts.length - 1;
  while (low < high) {
    const mid = low + high + 1 >> 1;
    if (rangeStarts[mid] <= codePoint) {
      low = mid;
    } else {
      high = mid - 1;
    }
  }
  return rangeClasses[low];
};
const canBreakBetween = (before, after) => {
  const codePoints = Array.from(before + after);
  if (codePoints.length !== 2) return false;
  const first = getLineBreakClass(codePoints[0].codePointAt(0) ?? 0);
  const second = getLineBreakClass(codePoints[1].codePointAt(0) ?? 0);
  if (first === BK || first === LF || first === NL) return true;
  if (first === CR) return second !== LF;
  if (second === SP || second === BK || second === LF || second === NL || second === CR) return false;
  if (first === ZWJ) return false;
  const pair = PAIR_TABLE[first === SP ? WJ : first].charCodeAt(second) - 48;
  if (pair === DI_BRK) return true;
  return first === SP && (pair === IN_BRK || pair === CI_BRK);
};
export {
  canBreakBetween,
  getLineBreakClass
};
